import { Suspense, lazy, type ReactNode } from "react";
import { createBrowserRouter } from "react-router-dom";
import App from "./App";

const MainPage = lazy(() => import("../pages/MainPage"));
const ProductPage = lazy(() => import("../pages/ProductPage"));
const ProductDetailPage = lazy(() => import("../pages/ProductDetailPage"));
const Lens24Page = lazy(() => import("../pages/Lens24Page"));
const PlacePage = lazy(() => import("../pages/PlacePage"));
const NotFoundPage = lazy(() => import("../pages/NotFoundPage"));

function LazyPage({ children }: { children: ReactNode }) {
  return <Suspense fallback={null}>{children}</Suspense>;
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: (
          <LazyPage>
            <MainPage />
          </LazyPage>
        ),
      },
      {
        path: "product",
        element: (
          <LazyPage>
            <ProductPage />
          </LazyPage>
        ),
      },
      {
        path: "product/:id",
        element: (
          <LazyPage>
            <ProductDetailPage />
          </LazyPage>
        ),
      },
      {
        path: "lens24",
        element: (
          <LazyPage>
            <Lens24Page />
          </LazyPage>
        ),
      },
      {
        path: "place",
        element: (
          <LazyPage>
            <PlacePage />
          </LazyPage>
        ),
      },
    ],
  },
  {
    path: "*",
    element: (
      <LazyPage>
        <NotFoundPage />
      </LazyPage>
    ),
  },
]);

export default router;
